import { useMutation } from '@tanstack/react-query'

import client, { Schemas } from '~/clients/api-client'
import { dispatchErrorToast, dispatchSuccessToast } from '~/store/slices/toasterSlice'

import { handleApiRequest } from '../shared/apiWrapper'
import { DEFAULT_SUPPORT_SUBMIT_ERROR_MESSAGE, formatSupportApiError } from './supportApi'

type CreateSupportTicketVariables = Schemas['SupportTicketRequest']

type UseCreateSupportTicketMutationOptions = {
    successToast: string
    onSuccess?: () => void
}

export const useCreateSupportTicketMutation = (options: UseCreateSupportTicketMutationOptions) =>
    useMutation({
        mutationFn: async (body: CreateSupportTicketVariables) =>
            handleApiRequest({
                apiCall: () => client.createSupportTicket(body),
                options: { errorFormatter: formatSupportApiError },
            }),
        onSuccess: () => {
            dispatchSuccessToast(options.successToast)
            options.onSuccess?.()
        },
        onError: (error: Error) => {
            console.error('Failed to create support ticket', error)
            dispatchErrorToast({ message: error.message || DEFAULT_SUPPORT_SUBMIT_ERROR_MESSAGE })
        },
    })
